<h2 mat-dialog-title>Gestionar Tipo de Cambio</h2>
<mat-dialog-content class="dialog-content">
  <form [formGroup]="exchangeForm" class="exchange-form">
    <div class="form-row">
      <label class="form-label">Fecha de Cambio<span class="required">*</span></label>
      <mat-form-field appearance="outline" class="form-input">
        <input matInput [matDatepicker]="picker" formControlName="date" required>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="exchangeForm.get('date')?.hasError('required')">
          La fecha es requerida
        </mat-error>
      </mat-form-field>
    </div>

    <div class="inline-loader" *ngIf="isCheckingDate">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Verificando registro...</span>
    </div>

    <ng-container *ngIf="!isCheckingDate">
      <div class="form-row">
        <label class="form-label">Compra<span class="required">*</span></label>
        <mat-form-field appearance="outline" class="form-input">
          <mat-icon matPrefix class="form-prefix">
            <i-tabler name="number" class="icon-20 d-flex"></i-tabler>
          </mat-icon>
          <input matInput type="number" formControlName="buy" step="0.00001" placeholder="1.10000" required>
          <mat-error *ngIf="exchangeForm.get('buy')?.hasError('required')">
            El tipo de cambio de compra es requerido
          </mat-error>
          <mat-error *ngIf="exchangeForm.get('buy')?.hasError('pattern')">
            Formato inválido. Usa hasta 5 decimales
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <label class="form-label">Venta<span class="required">*</span></label>
        <mat-form-field appearance="outline" class="form-input">
          <mat-icon matPrefix class="form-prefix">
            <i-tabler name="number" class="icon-20 d-flex"></i-tabler>
          </mat-icon>
          <input matInput type="number" formControlName="sell" step="0.00001" placeholder="1.10000" required>
          <mat-error *ngIf="exchangeForm.get('sell')?.hasError('required')">
            El tipo de cambio de venta es requerido
          </mat-error>
          <mat-error *ngIf="exchangeForm.get('sell')?.hasError('pattern')">
            Formato inválido. Usa hasta 5 decimales
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <label class="form-label">Cierre Compra</label>
        <mat-form-field appearance="outline" class="form-input">
          <mat-icon matPrefix class="form-prefix">
            <i-tabler name="number" class="icon-20 d-flex"></i-tabler>
          </mat-icon>
          <input matInput type="number" formControlName="closeBuy" step="0.00001" placeholder="1.10000">
          <mat-error *ngIf="exchangeForm.get('closeBuy')?.hasError('pattern')">
            Formato inválido. Usa hasta 5 decimales
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <label class="form-label">Cierre Venta</label>
        <mat-form-field appearance="outline" class="form-input">
          <mat-icon matPrefix class="form-prefix">
            <i-tabler name="number" class="icon-20 d-flex"></i-tabler>
          </mat-icon>
          <input matInput type="number" formControlName="closeSell" step="0.00001" placeholder="1.10000">
          <mat-error *ngIf="exchangeForm.get('closeSell')?.hasError('pattern')">
            Formato inválido. Usa hasta 5 decimales
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button (click)="close()" class="cancel-button">Cancelar</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="!exchangeForm.valid">Guardar</button>
</mat-dialog-actions>